import { bool, func, node, object } from 'prop-types';
import React, { forwardRef } from 'react';
import { BodyText, Heading3 } from '../Type';
import FieldRegistry from './FieldRegistry';
import FormButtons from './FormButtons';
import FormErrors from './FormErrors';
import TriggerSuccessCallback from './TriggerSuccessCallback';
const FormContent = forwardRef(({ title, legend, children, renderButtons, renderAfterLabel, disabled, showAllErrors, fieldErrorMessage, subscription, onSuccess, }, refForErrorAlert) => {
    return (React.createElement(FieldRegistry, { isFormDisabled: disabled, showAllErrors: showAllErrors, renderAfterLabel: renderAfterLabel },
        title && React.createElement(Heading3, { noTopSpacer: true }, title),
        legend && React.createElement(BodyText, { className: 'kal-form-legend' }, legend),
        children,
        React.createElement(FormErrors, { fieldErrorMessage: fieldErrorMessage, ref: refForErrorAlert }),
        React.createElement(TriggerSuccessCallback, { onSuccess: onSuccess }),
        React.createElement(FormButtons, { renderButtons: renderButtons, subscription: subscription, disabled: disabled })));
});
FormContent.propTypes = {
    title: node,
    legend: node,
    children: node,
    renderButtons: func,
    renderAfterLabel: func,
    disabled: bool,
    showAllErrors: bool,
    fieldErrorMessage: node,
    subscription: object,
    onSuccess: func,
};
FormContent.displayName = 'FormContent';
export default React.memo(FormContent);
//# sourceMappingURL=FormContent.js.map